import adminMiddleware from "@/components/permissions/admin/ducks/middleware"
import internalMiddleware from "@/components/permissions/internal/ducks/middleware"

export default [adminMiddleware, internalMiddleware]
